export const FILTERS_SET = 'FILTERS_SET';
export const FILTERS_SET_CRITERIA_STRICTNESS =
  'FILTERS_SET_CRITERIA_STRICTNESS';
export const FILTERS_SET_UPDATING = 'FILTERS_SET_UPDATING';
